import { ShieldHomeIcon } from './ShieldHomeIcon';

/**
 * author: Austin Andrews
 * id 2A5A98F5-ED95-40DE-8EC5-1293795CF661
 * name shield-home
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-home.svg
 * tags
 * - Home Automation 
 */
export const SecurityHomeIcon = ShieldHomeIcon;
export default SecurityHomeIcon